import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import CountDownTimer from './CountdownTimer';
import "./ConfirmReservationModal.css";
import { formatPhoneNumber } from './functions';
function ConfirmReservationModal({ course, setCourse, requirePayment, setShowPaymentModal, reservation, handleReserveNow, assertSlotAvailable, removeReservationTime, userData, user, setPageLoaderStatus, setReservation, handleTeeGroupGolfersInputChange }) {
  const [show, setShow] = useState(false);
  const openedForReservationId = useRef<string | null>(null);

  useEffect(() => {
    if (reservation.id && openedForReservationId.current !== reservation.id) {
      openedForReservationId.current = reservation.id;
      setShow(true);
      console.log("CONFIRMING RESERVATION", reservation);
    }
    if (!reservation.id) {
      openedForReservationId.current = null;
      setShow(false);
    }
  }, [reservation.id]);

  const handleCancel = () => {
    removeReservationTime();
    setShow(false);
  }

  const handleReserveNowButton = async () => {
    const ok = await handleReserveNow();
    if (ok) {
      setShow(false);
    }
  }

  const handlePayNow = async () => {
    const available = await assertSlotAvailable();
    if (!available) return;
    setShow(false);
    setShowPaymentModal(true);
  }

  // console.log("Require Payment +++++: ", requirePayment);

  return (
    <div className="modalContainer">
      <Modal id="confirmReservationModal" centered show={show} onHide={handleCancel} backdrop="static" className="text-center">
        <Modal.Header className="text-center d-block">
          <Modal.Title>Confirm Reservation</Modal.Title>

        </Modal.Header>
        {!reservation.expiration && !reservation.expiresAt && <div className="alert alert-danger mt-3 mx-3">Your time expired. Please try again.</div>}
        {(reservation.expiration || reservation.expiresAt) &&
          <>
            <CountDownTimer expiresAt={reservation.expiresAt} expiration={reservation.expiration} resID={reservation.id} deleteGroup={removeReservationTime}></CountDownTimer>

            <Modal.Body>
              <p>Please confirm your reservation below.</p>

              <p>You are booking <strong>{reservation.numPlayers} {reservation.numPlayers > 1 ? "players" : "player"}</strong>
                &nbsp;for <strong>{reservation.numHoles} holes</strong>
                &nbsp;at <strong>{reservation.time}</strong>
                &nbsp;on <strong>{moment(reservation.date, 'YYYY-MM-D').format('dddd, MMMM D, YYYY')}</strong>
                &nbsp;at <strong>{course?.name}</strong>.</p>

              <table className="table reservationInfoTable">
                <tbody>
                  <tr>
                    <td className="text-start">Name</td>
                    <td className="text-end">{userData?.firstName} {userData?.lastName}</td>
                  </tr>
                  <tr>
                    <td className="text-start">Phone</td>
                    <td className="text-end">{formatPhoneNumber(userData?.phone)}</td>
                  </tr>
                  <tr>
                    <td className="text-start">Email</td>
                    <td className="text-end">{user?.email}</td>
                  </tr>
                </tbody>
              </table>

              {course?.rates?.length && //show rates section if course has them.
                <>
                  <p className="text-center"><strong>Select rate for each golfer.</strong><br></br><small>{"(Rate will be confirmed when you check in)"}</small></p>
                  <table className="table reservationInfoTable">
                    <tbody>
                      {reservation.golfers.map((golfer, i) =>
                        <tr>
                          <td className="text-start">{golfer.name}</td>
                          <td className="text-end">
                            <select className="form-select" value={golfer.rateGroup} name="rateGroup" onChange={event => handleTeeGroupGolfersInputChange({ event, index: i })}>
                              {course?.rates?.map((rateGroup, i) =>
                                <option value={i}>{rateGroup?.name}</option>
                              )}
                            </select>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </>
              }
              {!requirePayment &&
                <p className="mb-0">If this looks correct, click <strong>"Reserve Now"</strong> below to finalize your reservation.</p>
              }
              {requirePayment &&
                <p className="mb-0">This reservation requires payment in advance. Please click <strong>"Reserve Now"</strong> below to finalize your reservation.</p>
              }
            </Modal.Body>
          </>
        }
        <Modal.Footer className="footerButtons">
          <Button variant="danger" onClick={handleCancel}>
            Cancel
          </Button>
          {/* {requirePayment &&
            <Button variant="primary" onClick={handlePayNow}>
              Reserve Now
            </Button>
          }
          {!requirePayment &&
            <Button variant="primary" onClick={handleReserveNowButton}>
              Reserve Now
            </Button>
          } */}

          {(requirePayment || reservation.requirePayment) &&
            <Button variant="primary" onClick={handlePayNow}>
              Reserve Now
            </Button>
          }
          {(!requirePayment && !reservation.requirePayment) &&
            <Button variant="primary" onClick={handleReserveNowButton}>
              Reserve Now
            </Button>
          }
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default ConfirmReservationModal